/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { $el, createElem, getBooleanTypeAttr, getStrTypeAttr, removeAttrs, setHtml } from '../../dom-utils';
import { moreThanOneNode } from '../../mixins';
import { type, validComps } from '../../utils';
import PREFIX from '../prefix';
var Card = /** @class */ (function () {
    function Card() {
        this.VERSION = 'v1.0';
        this.COMPONENTS = $el('r-card', { all: true });
        this._create(this.COMPONENTS);
    }
    Card.prototype.config = function (el) {
        var target = $el(el);
        validComps(target, 'card');
        var CardHead = target.querySelector("." + PREFIX.card + "-head");
        var CardExtra = target.querySelector("." + PREFIX.card + "-extra");
        return {
            get title() {
                return setHtml(CardHead);
            },
            set title(newVal) {
                if (newVal && !type.isStr(newVal))
                    return;
                setHtml(CardHead, newVal);
            },
            get extra() {
                return setHtml(CardExtra);
            },
            set extra(newVal) {
                if (newVal && !type.isStr(newVal))
                    return;
                setHtml(CardExtra, newVal);
            }
        };
    };
    Card.prototype._create = function (COMPONENTS) {
        var _this = this;
        COMPONENTS.forEach(function (node) {
            if (moreThanOneNode(node))
                return;
            var placeholderNode = node.firstElementChild;
            var _a = _this._attrs(node), title = _a.title, extra = _a.extra, shadow = _a.shadow, noBorder = _a.noBorder, disHover = _a.disHover;
            _this._isShowBordered(node, noBorder);
            _this._isShowShadow(node, shadow);
            _this._isDisHover(node, disHover);
            _this._setHead(node, title);
            _this._setBody(node, placeholderNode);
            _this._setExtra(node, extra);
            removeAttrs(node, ['title', 'extra', 'shadow', 'dis-hover', 'bordered']);
        });
    };
    Card.prototype._isShowBordered = function (node, noBorder) {
        if (!noBorder)
            return;
        node.classList.add(PREFIX.card + "-no-border");
    };
    Card.prototype._isShowShadow = function (node, shadow) {
        if (!shadow)
            return;
        node.classList.add(PREFIX.card + "-shadow");
    };
    Card.prototype._isDisHover = function (node, disHover) {
        if (!disHover)
            return;
        node.classList.add(PREFIX.card + "-dis-hover");
    };
    Card.prototype._setHead = function (node, title) {
        if (!title)
            return;
        var CardHeadTemplate = "<div class=\"" + PREFIX.card + "-head\">" + title + "</div>";
        node.insertAdjacentHTML('afterbegin', CardHeadTemplate);
    };
    Card.prototype._setBody = function (node, placeholderNode) {
        var Fragment = document.createDocumentFragment();
        var CardBody = createElem('div');
        CardBody.className = PREFIX.card + "-body";
        CardBody.appendChild(placeholderNode);
        Fragment.appendChild(CardBody);
        node.appendChild(Fragment);
    };
    Card.prototype._setExtra = function (node, extra) {
        if (!extra)
            return;
        var CardExtraTemplate = "<div class=\"" + PREFIX.card + "-extra\">" + extra + "</div>";
        node.insertAdjacentHTML('beforeend', CardExtraTemplate);
    };
    Card.prototype._attrs = function (node) {
        return {
            title: getStrTypeAttr(node, 'title', ''),
            extra: getStrTypeAttr(node, 'extra', ''),
            shadow: getBooleanTypeAttr(node, 'shadow'),
            disHover: getBooleanTypeAttr(node, 'dis-hover'),
            noBorder: getBooleanTypeAttr(node, 'no-border')
        };
    };
    return Card;
}());
export default Card;
